import React, { Component } from 'react';
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
    Alert,
    CircularProgress,
    Breadcrumbs,
    Link as MuiLink,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Paper,
    Card,
    CardContent,
    Chip
} from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DescriptionIcon from '@mui/icons-material/Description';
import { isAuthenticated } from '../auth';
import { createNewFile } from './apiFiles';
import { groupDetails } from "../group/apigroup";
import { Link } from 'react-router-dom';
import Footer from '../core/Footer';

class CreateFile extends Component {

    constructor(props) {
        super(props)
        this.state = {
            title: '',
            description: '',
            fileCategory: '',
            file: '',
            groupId: this.props.match.params.groupId,
            groupName: '',
            formData: '',
            error: '',
            success: false,
            fileInputKey: '',
            loading: false
        }
        //any bindinds here
        this.fileForm = this.fileForm.bind(this);
        this.showSuccess = this.showSuccess.bind(this);
        this.showError = this.showError.bind(this);
        this.getCommitteeName = this.getCommitteeName.bind(this);
    }

    token = isAuthenticated() && isAuthenticated().token;
    userId = isAuthenticated().userId

    componentDidMount() {
        this.setState({formData : new FormData() });        
        this.getCommitteeName(this.state.groupId)
    };


    handleChange = name => event => {
        let value = "";
        if (name === 'file') {
            value = event.target.files[0]
        } else {
            value = event.target.value
        }
        this.setState({ error: "" });
        this.setState({ [name]: value });
        this.state.formData.append(name, value);
    };

    getCommitteeName() {
        groupDetails(this.state.groupId).then(data => {
            if (data.error) {
                console.log(data.error);
            } else {
                this.setState({ groupName: data.name })
            }
        });
    };

    clickSubmit = event => { 
        event.preventDefault();
        this.state.formData.append("groupId", this.state.groupId);
        this.setState({loading: true })
        createNewFile(this.token, this.userId, this.state.formData).then(data => {
            if (data.error) this.setState({ error: data.error, success: false });
            else
                this.setState({
                    error: "",
                    title: "",
                    description: "",
                    fileCategory: "",
                    file: "",
                    success: true,
                    formData: new FormData(),
                    groupId: this.props.match.params.groupId,
                    fileInputKey: this.state.file.value ? this.state.file.value.name : +new Date(),
                    loading: false
                });
        });
    };

    showError() {
        if (!this.state.error) return null;
        return (
            <Alert severity="error" sx={{ mb: 2 }}>
                {this.state.error}
            </Alert>
        )
    };
    showSuccess() {
        if (!this.state.success) return null;
        return (
            <Alert severity="success" sx={{ mb: 2 }}>
                File Created Successfully!
            </Alert>
        )
    };

    fileForm = () => (
        <Card elevation={3} sx={{ borderRadius: 3, overflow: 'visible' }}>
            <CardContent sx={{ p: 4 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <DescriptionIcon sx={{ fontSize: 32, color: '#003E7E', mr: 2 }} />
                    <Box>
                        <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E' }}>
                            Upload File
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Adding to {this.state.groupName}
                        </Typography>
                    </Box>
                </Box>

                <Box component="form">
                    <TextField
                        fullWidth
                        label="File Name"
                        onChange={this.handleChange("title")}
                        type="text"
                        value={this.state.title}
                        margin="normal"
                        variant="outlined"
                        helperText="Replaces the uploaded file name"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#003E7E',
                                },
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                                color: '#003E7E',
                            },
                        }}
                    />

                    <TextField
                        fullWidth
                        label="Description"
                        onChange={this.handleChange("description")}
                        multiline
                        rows={4}
                        value={this.state.description}
                        margin="normal"
                        variant="outlined"
                        helperText="Brief description of the file contents"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused fieldset': {
                                    borderColor: '#003E7E',
                                },
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                                color: '#003E7E',
                            },
                        }}
                    />

                    <FormControl
                        fullWidth
                        margin="normal"
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#003E7E',
                                },
                            },
                            '& .MuiInputLabel-root.Mui-focused': {
                                color: '#003E7E',
                            },
                        }}
                    >
                        <InputLabel>File Category</InputLabel>
                        <Select
                            value={this.state.fileCategory}
                            onChange={this.handleChange('fileCategory')}
                            label="File Category"
                        >
                            <MenuItem value=""><em>None</em></MenuItem>
                            <MenuItem value="SDSIC Leadership">SDSIC Leadership</MenuItem>
                            <MenuItem value="SDSIC Position Statement">SDSIC Position Statement</MenuItem>
                            <MenuItem value="SDSIC Proposals">SDSIC Proposals</MenuItem>
                            <MenuItem value="SDSIC Newsletter">SDSIC Newsletter</MenuItem>
                            <MenuItem value="SDSIC Event Links">SDSIC Event Links</MenuItem>
                            <MenuItem value="SDSIC Event Presentations">SDSIC Event Presentations</MenuItem>
                            <MenuItem value="SDSIC Event Handouts">SDSIC Event Handouts</MenuItem>
                            <MenuItem value="Lisp File">Lisp Files</MenuItem>
                            <MenuItem value="Script File">Script Files</MenuItem>
                            <MenuItem value="iLogic File">iLogic Files</MenuItem>
                            <MenuItem value="Training">Training</MenuItem>
                            <MenuItem value="Best Practices">Best Practices</MenuItem>
                            <MenuItem value="Presentation">Presentation</MenuItem>
                            <MenuItem value="White Paper">White Paper</MenuItem>
                            <MenuItem value="Meeting Agenda">Meeting Agenda</MenuItem>
                            <MenuItem value="Meeting Invite">Meeting Invite</MenuItem>
                            <MenuItem value="Meeting Minutes">Meeting Minutes</MenuItem>
                        </Select>
                    </FormControl>

                    <Paper
                        elevation={0}
                        sx={{
                            mt: 3,
                            p: 3,
                            border: '2px dashed #003E7E',
                            borderRadius: 2,
                            backgroundColor: 'rgba(0, 62, 126, 0.02)',
                            textAlign: 'center',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 62, 126, 0.05)',
                                borderColor: '#FF6600',
                            }
                        }}
                    >
                        <input
                            key={this.state.fileInputKey}
                            onChange={this.handleChange("file")}
                            type="file"
                            accept="*"
                            style={{ display: 'none' }}
                            id="file-upload"
                        />
                        <label htmlFor="file-upload" style={{ cursor: 'pointer', width: '100%', display: 'block' }}>
                            <CloudUploadIcon sx={{ fontSize: 48, color: '#003E7E', mb: 1 }} />
                            <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E', mb: 0.5 }}>
                                {this.state.file ? this.state.file.name : 'Click to upload file'}
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                {this.state.file ? 'Click to change file' : 'Any file type accepted'}
                            </Typography>
                        </label>
                    </Paper>

                    <Button
                        onClick={this.clickSubmit}
                        variant="contained"
                        disabled={!this.state.file}
                        fullWidth
                        size="large"
                        startIcon={<UploadFileIcon />}
                        sx={{
                            mt: 3,
                            py: 1.5,
                            backgroundColor: '#003E7E',
                            fontSize: '1.1rem',
                            fontWeight: 600,
                            textTransform: 'none',
                            boxShadow: '0 4px 12px rgba(0, 62, 126, 0.3)',
                            '&:hover': {
                                backgroundColor: '#FF6600',
                                boxShadow: '0 6px 16px rgba(255, 102, 0, 0.4)',
                            },
                            '&:disabled': {
                                backgroundColor: '#ccc',
                            }
                        }}
                    >
                        Upload File
                    </Button>
                </Box>
            </CardContent>
        </Card>
    );

    render() {
        return (
            <>
                {/* Hero Section */}
                <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 4, mb: 4 }}>
                    <Container maxWidth="lg">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <CloudUploadIcon sx={{ fontSize: 48 }} />
                            <Box>
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 600, mb: 0.5 }}>
                                    Upload New File
                                </Typography>
                                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                                    Share documents and resources with your committee
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>

                <Container maxWidth="md" sx={{ mb: 6 }}>
                    {this.state.loading && (
                        <Paper elevation={3} sx={{ p: 6, borderRadius: 3, textAlign: 'center' }}>
                            <CircularProgress size={60} sx={{ mb: 3, color: '#003E7E' }} />
                            <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E', mb: 1 }}>
                                Uploading your file...
                            </Typography>
                            <Typography variant="body1" color="text.secondary">
                                Please wait while we process your upload
                            </Typography>
                        </Paper>
                    )}

                    {!this.state.loading && (
                        <>
                            <Breadcrumbs
                                separator={<NavigateNextIcon fontSize="small" />}
                                sx={{
                                    mb: 3,
                                    '& .MuiLink-root': {
                                        color: '#003E7E',
                                        textDecoration: 'none',
                                        '&:hover': {
                                            color: '#FF6600',
                                            textDecoration: 'underline'
                                        }
                                    }
                                }}
                            >
                                <MuiLink
                                    component={Link}
                                    to={`/singleGroup/${this.props.match.params.groupId}`}
                                >
                                    {this.state.groupName}
                                </MuiLink>
                                <Typography color="text.primary" sx={{ fontWeight: 500 }}>
                                    Upload File
                                </Typography>
                            </Breadcrumbs>

                            {this.showError()}
                            {this.showSuccess()}

                            {this.fileForm()}
                        </>
                    )}
                </Container>

                <Footer />
            </>
        )
    }

};

export default CreateFile;